// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## SaleTarget Get
/**
 *
 * @param {{params: object, query: { searchKey: string, regionId: string, companyId: string, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetSaleTargetByRegion = async (option) => {
  console.log("bırada?", option);
  const response = await $api.get(
    Endpoints.SaleTarget.GetSaleTargetByRegion(option)
  );

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## SaleTarget Create
/**
 *
 * @param {{ query: { regionId: string, page: number, limit: number } }} option
 *
 * @returns
 */
export const GetSaleTargetByProduct = async (option) => {
  const response = await $api.get(
    Endpoints.SaleTarget.GetSaleTargetByProduct(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SaleTarget Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetSaleTargetByProductCategory = async (option) => {
  const response = await $api.get(
    Endpoints.SaleTarget.GetSaleTargetByProductCategory(option)
  );

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## SaleTarget Get ById
/**
 *
 * @param {{params: object, query: { regionId: string, companyId: string, page: number, limit: number, month: number, year: number }}} option
 
 * @returns
 */
export const GetEmployeeBonus = async (option) => {
  const response = await $api.get(
    Endpoints.SaleTarget.GetEmployeeBonus(option)
  );

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetSaleTargetByRegion,
  GetSaleTargetByProduct,
  GetSaleTargetByProductCategory,
  GetEmployeeBonus,
};
